import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import Eyebrow from '@/components/generals/eyebrow'

interface TechniqueChapterProps {
    id: string
    number: string
    eyebrow: string
    title: string
    figure: ReactNode
    children: ReactNode
    reversed?: boolean
}

const TechniqueChapter: FC<TechniqueChapterProps> = ({
    id,
    number,
    eyebrow,
    title,
    figure,
    children,
    reversed = false
}): ReactNode => {
    const headingId = `${id}-heading`

    return (
        <section id={id} aria-labelledby={headingId} className='relative scroll-mt-28 py-20 sm:py-28'>
            <div className='mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-12 lg:gap-20 lg:px-10'>
                <div className={cn('lg:col-span-6', reversed && 'lg:order-2')}>
                    <p aria-hidden='true' className='font-heading text-7xl leading-none text-gold/20 sm:text-8xl'>
                        {number}
                    </p>

                    <Eyebrow className='mt-2'>{eyebrow}</Eyebrow>

                    <h2 id={headingId} className='mt-5 text-4xl font-medium leading-[1.1] text-parchment sm:text-5xl'>
                        {title}
                    </h2>

                    <div className='mt-8 space-y-6 text-base leading-[1.8] text-parchment/80 sm:text-lg sm:leading-[1.8]'>
                        {children}
                    </div>
                </div>

                <div className={cn('lg:col-span-6', reversed && 'lg:order-1')}>
                    {figure}
                </div>
            </div>
        </section>
    )
}

export default TechniqueChapter
